<template>
  <div class="size-control" v-show="selectedWidget">
    <div
      :style="{
        top: elm.top - halfSquare + 'px',
        left: elm.left - halfSquare + 'px'
      }"
      class="nwse"
      @mousedown="handlemousedown($event, ['up' ,'left'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top + (elm.height / 2) - halfSquare + 'px',
        left: elm.left - halfSquare + 'px'
      }"
      class="verti"
      @mousedown="handlemousedown($event, ['left'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top + elm.height - halfSquare + 'px',
        left: elm.left - halfSquare + 'px'
      }"
      class="nesw"
      @mousedown="handlemousedown($event, ['down', 'left'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top + elm.height - halfSquare + 'px',
        left: elm.left + (elm.width / 2) - halfSquare + 'px'
      }"
      class="horiz"
      @mousedown="handlemousedown($event, ['down'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top + elm.height - halfSquare + 'px',
        left: elm.left + elm.width - halfSquare + 'px'
      }"
      class="nwse"
      @mousedown="handlemousedown($event, ['down', 'right'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top + (elm.height / 2) - halfSquare + 'px',
        left: elm.left + elm.width - halfSquare + 'px'
      }"
      class="verti"
      @mousedown="handlemousedown($event, ['right'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top - halfSquare + 'px',
        left: elm.left + elm.width - halfSquare + 'px'
      }"
      class="nesw"
      @mousedown="handlemousedown($event, ['up', 'right'])">
      <div class="square"/>
    </div>

    <div
      :style="{
        top: elm.top - halfSquare + 'px',
        left: elm.left + (elm.width / 2) - halfSquare + 'px'
      }"
      class="horiz"
      @mousedown="handlemousedown($event, ['up'])">
      <div class="square"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SizeControl',
  props: {
    selectedWidget: {
      type: Object,
    },
  },
  data() {
    return {
      types: [], // left | right | up | down
      keepRatio: false,
      startX: 0,
      startY: 0,
      originX: 0,
      originY: 0,
      originWidth: 0,
      originHeight: 0,
      cursorPageX: 0,
      cursorPageY: 0,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    window.addEventListener('keyup', this.keyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDown);
    window.removeEventListener('keyup', this.keyUp);
  },
  computed: {
    elm() {
      return this.selectedWidget || {};
    },
    halfSquare() {
      return 5;
    },
  },

  methods: {
    keyDown(e) {
      if (e.key === 'Shift') {
        this.setKeepRatio(true);
      }
    },
    keyUp(e) {
      if (e.key === 'Shift') {
        this.setKeepRatio(false);
      }
    },
    setKeepRatio(value) {
      this.keepRatio = value;
      if (this.types.length) {
        this.resize();
      }
    },
    handlemousedown(e, types) {
      e.stopPropagation();

      this.types = types;
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.originX = this.selectedWidget.left;
      this.originY = this.selectedWidget.top;
      this.originWidth = this.selectedWidget.width;
      this.originHeight = this.selectedWidget.height;

      document.addEventListener('mousemove', this.handlemousemove, true);
      document.addEventListener('mouseup', this.handlemouseup, true);
    },

    handlemousemove(e) {
      e.stopPropagation();
      e.preventDefault();

      this.cursorPageX = e.pageX;
      this.cursorPageY = e.pageY;

      this.resize();
    },
    resize() {
      const dx = this.cursorPageX - this.startX;
      const dy = this.cursorPageY - this.startY;

      if (_.some(this.types, t => t === 'right')) {
        this.expandRight(dx);
        if (this.keepRatio) {
          const dy = Math.round((this.originHeight / this.originWidth) * dx);
          if (_.some(this.types, t => t === 'up')) {
            this.expandUp(-dy);
          } else {
            this.expandDown(dy);
          }
        }
      }

      if (_.some(this.types, t => t === 'left')) {
        this.expandLeft(dx);
        if (this.keepRatio) {
          const dy = Math.round((this.originHeight / this.originWidth) * dx);
          if (_.some(this.types, t => t === 'up')) {
            this.expandUp(dy);
          } else {
            this.expandDown(-dy);
          }
        }
      }

      if (this.keepRatio && this.types.length > 1) {
        return;
      }

      if (_.some(this.types, t => t === 'down')) {
        this.expandDown(dy);
        if (this.keepRatio) {
          const dx = Math.round((this.originWidth / this.originHeight) * dy);
          if (_.some(this.types, t => t === 'left')) {
            this.expandLeft(-dx);
          } else {
            this.expandRight(dx);
          }
        }
      }

      if (_.some(this.types, t => t === 'up')) {
        this.expandUp(dy);
        if (this.keepRatio) {
          const dx = Math.round((this.originWidth / this.originHeight) * dy);
          if (_.some(this.types, t => t === 'left')) {
            this.expandLeft(dx);
          } else {
            this.expandRight(-dx);
          }
        }
      }
    },

    expandRight(dx) {
      const MIN_WIDTH = 30;
      this.selectedWidget.width = Math.max(this.originWidth + dx, MIN_WIDTH);
    },

    expandLeft(dx) {
      const MIN_WIDTH = 30;
      this.selectedWidget.left = Math.min(this.originX + dx, (this.originX + this.originWidth) - MIN_WIDTH);
      this.selectedWidget.width = Math.max(this.originWidth - dx, MIN_WIDTH);
    },

    expandUp(dy) {
      const MIN_HEIGHT = 30;
      this.selectedWidget.top = Math.min(this.originY + dy, (this.originY + this.originHeight) - MIN_HEIGHT);
      this.selectedWidget.height = Math.max(this.originHeight - dy, MIN_HEIGHT);
    },

    expandDown(dy) {
      const MIN_HEIGHT = 30;
      this.selectedWidget.height = Math.max(this.originHeight + dy, MIN_HEIGHT);
    },

    handlemouseup() {
      document.removeEventListener('mousemove', this.handlemousemove, true);
      document.removeEventListener('mouseup', this.handlemouseup, true);
      this.types = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.size-control {
  .verti, .horiz, .nesw, .nwse {
    position: absolute;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .verti {
    cursor: ew-resize;
  }

  .horiz {
    cursor: ns-resize;
  }

  .nesw {
    cursor: nesw-resize;
  }

  .nwse {
    cursor: nwse-resize;
  }

  .square {
    width: 10px;
    height: 10px;
    border: 1px solid #2196f3;
    background-color: #fff;
    flex-shrink: 0;
  }
}
</style>
